<template>
    <content-view>
        <div slot="header">
            <a-form :form="form" layout="inline" >
                <a-form-item label="商品名称">
                    <a-input placeholder="请输入" v-decorator="['goodsName']"></a-input>
                </a-form-item>
                <a-form-item label="商品编号">
                    <a-input placeholder="请输入" v-decorator="['serialNum']"></a-input>
                </a-form-item>
                <a-form-item class="wrap-header-button">
                    <a-button type="primary" @click="search">筛选</a-button>
                    <a-button @click="handleReset()">重置</a-button>
                </a-form-item>
            </a-form>
            <a-tabs v-if="warehouseLevel == 1" defaultActiveKey="1" @change="callback1" class="tradeRecord_tab">
                <a-tab-pane tab="售卖" key="1"></a-tab-pane>
                <a-tab-pane tab="自用" key="2" forceRender></a-tab-pane>
            </a-tabs>
            <a-tabs v-else defaultActiveKey="1" @change="callback2" class="tradeRecord_tab">
                <a-tab-pane tab="展示至票台" key="1"></a-tab-pane>
                <a-tab-pane tab="不展示至票台" key="0" forceRender></a-tab-pane>
            </a-tabs>
        </div>
        <div class="trade-record">
            <div class="flex">
                <p class="trade-record_title mb8">
                    <a-icon type="info-circle" style="padding-right: 8px;color: #FFBF00;margin-top: 2px;"/>当前仓库 - {{storageName}}
                </p>
                <a-button @click="exportStorage" :loading="exportLoading" type="primary" class="ml16 mb8">导出</a-button>
            </div>
            <a-table
                bordered
                :dataSource="dataSource"
                :columns="columns"
                :pagination="pagination"
                :rowKey="record => record.goodId"
                @change="changePage"
            >
                <span slot="goodsSize" slot-scope="goodsSize">{{goodsSize ? goodsSize : "-"}}</span>
                <span slot="action" slot-scope="a,row">
                    <span v-if="warehouseLevel == 2">/</span>
                    <span v-else>
                        <a class="text-primary" @click="addBound(row)">添加库存</a>
                    </span>
                </span>
            </a-table>
        </div>
        <a-modal title="添加库存" v-model="addBoundVisible" @ok="addBoundSave">
            <div class="add-bound">
                <a-row>
                    <a-col :span="12"> 商品编号：{{goodsDetail.serialNum}} </a-col>
                    <a-col :span="12"> 商品名称：{{goodsDetail.goodsName}} </a-col>
                </a-row>
                <a-row>
                    <a-col :span="12"> 商品类型：{{goodsDetail.goodsType}} </a-col>
                    <a-col :span="12"> 商品规格：{{goodsDetail.goodsSize}} </a-col>
                </a-row>
                <a-row>
                    <a-col :span="12"> 商品单位：{{goodsDetail.goodsUnit}} </a-col>
                    <a-col :span="12"> 仓库名称：{{storageName}} </a-col>
                </a-row>
                <a-row>
                    <a-col :span="12"> 当前库存量：{{goodsDetail.currentInventory}} </a-col>
                </a-row>
            </div>
            <div>
                本次入库数：<a-input-number
                        v-model="goodsDetail.num"
                        :min="1"
                        :precision="0"
                        suffix="个"
                        placeholder="请输入"
                    />
            </div>
        </a-modal>
    </content-view>
</template>

<script type="text/javascript">
    import { mapGetters } from "vuex";
    let columns = [
        {
            title: '商品编号',
            dataIndex: 'serialNum',
        },
        {
            title: '商品名称',
            dataIndex: 'goodsName'
        },
        {
            title: '商品类型',
            dataIndex: 'goodsType'
        },
        {
            title: '商品规格',
            dataIndex: 'goodsSize',
            scopedSlots: { customRender: 'goodsSize' }
        },
        {
            title: '单位',
            dataIndex: 'goodsUnit'
        },
        {
            title: '当前库存量',
            dataIndex: 'currentInventory'
        },
        {
            title: '总入库量',
            dataIndex: 'totalInventory'
        },
        {
            title: '操作',
            dataIndex: 'action',
            scopedSlots: { customRender: 'action' }
        }];
    export default {
        name: 'storageSave',
        components: {},
        props: {},
        data() {
            return {
                columns,
                dataSource: [],
                pagination: {
                    showTotal: total => `共 ${total} 条数据`,
                    showSizeChanger: true,
                    showQuickJumper: true,
                    total: 0,
                    current: 1,
                    pageSize: 20
                },
                storageName: this.$route.query.name,
                warehouseLevel: this.$route.query.warehouseLevel,
                addBoundVisible: false,
                goodsDetail: {},
                useType: undefined,
                ticketCounterShow: undefined,
                form: this.$form.createForm(this), //筛选表单
                exportLoading: false
            };
        },
        computed: {
            ...mapGetters(["shopId"])
        },
        methods: {
            // 重置筛选
            handleReset() {
                this.form.resetFields();
                this.warehouseList();
            },
            search() {
                this.pagination.current = 1;
                this.warehouseList();
            },
            //分页回调
            changePage(page) {
                this.pagination.pageSize = page.pageSize;
                this.pagination.current = page.current;
                this.warehouseList();
            },
            callback1(key) {
                this.useType = key
                this.warehouseList();
            },
            callback2(key) {
                this.ticketCounterShow = key
                this.warehouseList();
            },
            warehouseList() {
                this.form.validateFields((err, values) => {
                    if (err) return;
                    const params = {};
                    if (values.serialNum) {
                        params.serialNum = values.serialNum;
                    }
                    if (values.goodsName) {
                        params.goodsName = values.goodsName;
                    }
                    this.$api.storage
                    .storageSave({
                        body: {
                            ...params,
                            pageNum: this.pagination.current,
                            pageSize: this.pagination.pageSize,
                            useType: this.useType,
                            ticketCounterShow: this.ticketCounterShow,
                            warehouseId: this.$route.query.id,
                        }
                    })
                    .then(res => {
                        this.dataSource = res.data;
                        this.pagination.total = res.total;
                    });
                })
               
            },
            // 添加库存
            addBound(row) {
                this.addBoundVisible = true
                this.goodsDetail = row
            },
            addBoundSave() {
                if(!this.goodsDetail.num) {
                    this.$message.error('请输入本次入库数')
                    return false
                }

                this.$api.storage.addStockNum({
                    body: {
                        goodsId: this.goodsDetail.goodId,
                        num: this.goodsDetail.num,
                    }
                }).then(res => {
                    this.$message.success('操作成功')
                    this.warehouseList()
                    this.addBoundVisible = false
                });
            },
            /**
             * @exportStorage 库存导出
             */
            exportStorage() {
                this.form.validateFields((errors,values) => {
                    if (errors) return;
                    this.exportLoading = true;
                    let reqData = {
                        ...values,
                        pageNum: 1,
                        pageSize: 9999999,
                        shopId: this.shopId,
                        warehouseId: this.$route.query.id
                        };
                        if(Number(this.warehouseLevel) === 1) {
                            reqData.useType = this.useType;
                        } else {
                            reqData.ticketCounterShow = this.ticketCounterShow;
                        }
                        this.$api.storage.exportStorage({
                            body: reqData
                        },{
                            responseType: "blob"
                        }).then(res => {
                            this.exportLoading = false;
                            if(Number(this.warehouseLevel) === 1) {
                                let useTypeString = this.useType === '1' ? '售卖' : '自用';
                                this.exportXlsx(res.data, this.storageName + '(' + useTypeString + ')');
                            } else {
                                let ticketCounterShowString = this.ticketCounterShow === '1' ? '展示至票台' : '不展示至票台';
                                this.exportXlsx(res.data, this.storageName + '(' + ticketCounterShowString + ')');
                            }
                            
                        }).catch(err => {
                            this.exportLoading = false;
                        });
                })
            },
            /**
             * @exportXlsx 导出excel
             */
            exportXlsx(data,fileName) {
                let a = document.createElement("a");
                let blob = new Blob([data], {
                    type: "application/vnd.ms-excel"
                });
                let downloadUrl = window.URL.createObjectURL(blob);
                let name = fileName + '-' + this.$moment().format('YYYY/MM/DD') + '.xls'
                a.setAttribute("href", downloadUrl);
                var reportName = decodeURI(name);
                a.setAttribute("download", reportName);
                a.click();
                this.exportLoading = false;
            },
        },
        created() {},
        mounted() {
            this.useType = this.warehouseLevel == 1 ? '1' : undefined
            this.ticketCounterShow = this.warehouseLevel == 1 ? undefined : '1'
            this.warehouseList()
        }
    };
</script>
<style lang="scss">
  .trade-record {
      background-color: #fff;
      padding: 24px 32px;
      border-radius: 2px;
      &_title {
          width: 100%;
          height: 40px;
          background: #fffbe6;
          border: 1px solid #ffe58f;
          border-radius: 4px;
          display: flex;
          align-items: center;
          font-size: 14px;
          color: rgba(0, 0, 0, 0.65);
          padding-left: 16px;
          box-sizing: border-box;
      }
  }
    .add-bound {
        background: rgba(250,250,250,1);
        border-radius: 4px;
        padding: 16px;
        line-height: 34px;
        margin-bottom: 16px;
    }
  .tradeRecord_tab {
      .ant-tabs-ink-bar {
          background-color: #1890ff;
      }
      .ant-tabs-nav .ant-tabs-tab-active {
          color: #1890ff;
      }
  }
</style>